module.exports = __webpack_public_path__ + "fabc90ef70a1dd66f84bb7e1f2412a7e.png";